// extracted by mini-css-extract-plugin
export default {"page":"statuses_page__dWtlY","container":"statuses_container__TXBhU"};